module.exports = __webpack_public_path__ + "static/media/Anthony.adef4556.png";